import { Pipe, PipeTransform } from '@angular/core';
import { TaskType } from '../../../types/task/TaskType';

@Pipe({
    name: 'taskTypeSeverity',
    standalone: true
})
export class TaskTypeSeverityPipe implements PipeTransform {

    transform(taskType: TaskType | undefined): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined {
        switch (taskType) {
            case TaskType.PUBLISH:
                return 'success';
            case TaskType.REQUEST_APPROVAL:
                return 'contrast';
            case TaskType.REVIEW:
                return 'warn';
            case TaskType.CHANGES_REQUESTED:
                return 'danger';
            case TaskType.SET_ACTIVE:
                return 'info';
            default:
                return undefined;
        }
    }

}
